function optional(source) {
  return source.prepend((payload) => payload ?? {});
}
export {
  optional
};
//# sourceMappingURL=optional.mjs.map
